/**
 * File navigation.js.
 */
(function( $ ) {
		let masthead          = $( '.site-header' ),
		    fixedHeaderSearch = $( '#megamenu-search-wrap' ),
		    fixedHeader       = $('.fixed-header-search-trigger');

		$( document ).ready( function() {
			const wpAdminBar = document.querySelector('#wp-toolbar');
			const mainContent = document.querySelector('#main');
			let isAnimationInProgress = false;

			if (wpAdminBar) {
				mainContent.classList.add('has-admin-bar');
			}

			//make sure Online Library members go to library by default
			let headerBookLink = $('.menu-item-object-book a'),
				getHeaderBookHref = headerBookLink.attr( 'href' ),
			    initialTop = wpAdminBar ? 32 : 0,
				prevScrollTop = 0;

			if ( 'undefined' !== typeof ISDA_Main.libraryAccessStatus ) {
				if ( ISDA_Main.libraryAccessStatus === 'PLUS' ) {
					//if online lib member, change bookstore link to online library link
					headerBookLink.attr( 'href', getHeaderBookHref + 'library' );
				}
			}

			//only fire megamenu on desktop
			if ( window.innerWidth > 767 ) {
				//only hide search the first time when fixed, if not already "open, and not on scroll
				if ( masthead.hasClass( 'fixed-header' ) && !fixedHeaderSearch.hasClass( 'open' ) ) {
					closeFixedSearch();
				}

				//apply fixed-header class
				fixTaxonomyNav();

				$( window ).scroll( fixTaxonomyNav );

				$( document ).keyup( function( e ) {
					if ( e.keyCode === 27 ) {
						//only hide search if it's fixed header
						if ( masthead.hasClass( 'fixed-header' ) ) {
							closeFixedSearch();
						}
					}
				} );

			} //window width check

			function fixTaxonomyNav() {
				let devBanner = $('.developer-env-banner'),
				    scrollTop = $(window).scrollTop();

				if (masthead.hasClass('fixed-header')) {
					if (scrollTop > prevScrollTop) {

						masthead.css( 'opacity', '0' );
						masthead.css( 'top', `-${masthead.height()}px`); // Hide the header (based on the header height)

						// Optionally hide the developer banner
						if ($('body').hasClass('developer-env')) {
							devBanner.css( 'top', `-${masthead.height()}px`);
							devBanner.css( 'opacity', '0');
						}
					} else {
						masthead.css( 'top', `${initialTop}${initialTop ? 'px' : ''}`); // Show the header
						masthead.css( 'opacity', '1' );

						if ($('body').hasClass('developer-env')) {
							devBanner.css( 'top', `${initialTop}${initialTop ? 'px' : ''}`);
							devBanner.css('opacity', '1');
						}
					}
				}

				/*
				 * Toggle 'fixed-header' class to masthead
				 */

				if (scrollTop > initialTop) {
					const additionalHeight = wpAdminBar ? 34 : 2

					if (($(document).height() - masthead.height() - additionalHeight) > $(window).height()) {
						masthead.addClass( 'fixed-header' );
					}

				} else {
					if (masthead.hasClass('fixed-header')) {
						masthead.css( 'top', '0'); // Hide the header (based on the header height)
						masthead.removeClass( 'fixed-header' );
					}
				}

				prevScrollTop = scrollTop;
			}

			function hideMenusForSearch() {
				const taxNav = $( '.desktop-nav-wrap' );
				// why is hide() instantaneous whereas visibility isn't?
				taxNav.addClass( 'hide-nav' );
			}

			function closeFixedSearch() {
				if (isAnimationInProgress) return;

				isAnimationInProgress = true
				$( '#btn-trigger-search .glyphicon' )
					.removeClass( 'glyphicon-remove' )
					.addClass( 'glyphicon-search' );
				fixedHeaderSearch.fadeOut(1000).removeClass( 'open', function(  ) {
					isAnimationInProgress = false;
				});
				showMenusForSearch();
			}

			function openFixedSearch() {
				if (isAnimationInProgress) return;

				isAnimationInProgress = true
				$('#btn-trigger-search .glyphicon')
					.removeClass('glyphicon-search')
					.addClass('glyphicon-remove');
				hideMenusForSearch();
				fixedHeaderSearch.fadeIn(1000).addClass('open', function() {
					$("#global-isda-search").focus();
					isAnimationInProgress = false;
				});
			}

			function showMenusForSearch() {
				const taxNav = $( '.desktop-nav-wrap' );

				taxNav.removeClass( 'hide-nav' );
			}

			//toggle fixed header search visiblity via button
			$( '#btn-trigger-search' ).on( 'click', function() {
				fixedHeader.addClass('show-close-btn');
				if ( fixedHeaderSearch.is( ':visible' ) ) {
					closeFixedSearch();
					fixedHeader.removeClass('show-close-btn');
				} else {
					openFixedSearch();
				}
			} );

			/*
			 * Add onhover behaviour for dropdown
			 */

			$('li.dropdown').on("mouseover", function () {
				if (window.innerWidth > 768) $(this).addClass('open');
			});

			$('li.dropdown').on("mouseleave", function () {
				if (window.innerWidth > 768) $(this).removeClass('open');
			});

			$( "#global-isda-search" ).on( "blur", function() {
				closeFixedSearch();
			} );
		} );//doc ready
	}
)( jQuery );

